import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/NKT-Service-Victoria_Dock.jpg'


const _hoisted_1 = {
  key: 3,
  class: "main-content"
}
const _hoisted_2 = { class: "top-menu" }
const _hoisted_3 = {
  key: 0,
  class: "page-content"
}
const _hoisted_4 = {
  key: 1,
  class: "page-content loading"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "spinner-border",
  role: "status"
}
const _hoisted_7 = {
  key: 0,
  class: "image-container"
}

import TopBar from './components/nav/TopBar.vue'
import NavBar from './components/nav/NavBar.vue'
import LoginBar from './components/nav/LoginBar.vue'
import Breadcrumb from './components/general/breadcrumbs/Breadcrumb.vue'
import ProjectSelector from './components/dropdowns/ProjectSelector.vue'
import { useProjectStore } from './stores/ProjectStore'
import { onMounted, getCurrentInstance, ref, computed } from 'vue'
import { MSAL } from './plugins/msal/msal'
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const msal: MSAL = getCurrentInstance()?.appContext.config.globalProperties.$msal
let store = useProjectStore()

const isLoggedIn = ref(false)
const msalInitialised = ref(false)

const route = useRoute()
const isAdminPage = computed(() => route?.meta?.isAdminPage ?? false)

onMounted(async () => {
  await msal.initialize()

  isLoggedIn.value = msal.isAuthenticated()
  msalInitialised.value = true
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (msalInitialised.value && isLoggedIn.value)
        ? (_openBlock(), _createBlock(TopBar, { key: 0 }))
        : _createCommentVNode("", true),
      (msalInitialised.value && isLoggedIn.value)
        ? (_openBlock(), _createBlock(NavBar, { key: 1 }))
        : _createCommentVNode("", true),
      (msalInitialised.value)
        ? (_openBlock(), _createBlock(LoginBar, {
            key: 2,
            "is-logged-in": isLoggedIn.value
          }, null, 8, ["is-logged-in"]))
        : _createCommentVNode("", true),
      (isLoggedIn.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(Breadcrumb, { class: "ms-bread-crumb" }),
              _createVNode(ProjectSelector)
            ]),
            (_unref(store).projectHasBeenSet || isAdminPage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_RouterView)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_unref(store).noProjects)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[0] || (_cache[0] = [
                        _createElementVNode("h1", null, "No Projects Available", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
                        _createElementVNode("span", { class: "visually-hidden" }, "Loading Project...", -1)
                      ])))
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    (!isLoggedIn.value && msalInitialised.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "logo",
            class: "responsive-image"
          }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ], 64))
}
}

})